import React from 'react';
import ReactDOM from "react-dom";
import Clients from './clients';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Axios from 'axios';
//import { jsPDF } from "jspdf";
//import * as html2canvas from 'html2canvas';
import Console from './console';
import Customer from './customer';
import History from './history';
import Items from './items';
import CustomerProfile from './customerProfile';
import UserProfile from './userProfile';
import ItemAdd from './itemAdd';
import Loader from './loader';

export default class Invoice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null,
            error: null,
            isLoaded: null,
            date: new Date(),
            date2: new Date()
        };
    }

    onChange = date => CustomerProfile.setDate(date)
    onChange2 = date2 => CustomerProfile.setDate2(date2)

    componentDidMount() {
        //Cliens data loading
        ReactDOM.render(
            <Clients />, document.getElementById('invoiceBody')
        );
    }

    clientsGet() {
        ReactDOM.render(
            <Clients />, document.getElementById('invoiceBody')
        );
    }

    itemsGet(companyID) {
        CustomerProfile.setCompanyID(companyID);
        new Customer().customerDataGet(companyID);
        ReactDOM.render(
            <Items />, document.getElementById('invoiceBody')
        );
    }

    customerRecording() {
        ReactDOM.render(
            <Customer value='Mentés' />, document.getElementById('invoiceBody')
        );
    }

    itemRecording() {
        ReactDOM.render(
            <ItemAdd value='Mentés' />, document.getElementById('invoiceBody')
        );
    }

    itemRecordingError() {
        ReactDOM.render(
            <ItemAdd value='Mentés' name='Valamelyik kötelező adatmező nem lett megadva!' />, document.getElementById('invoiceBody')
        );
    }

    itemRecordingPriceError() {
        ReactDOM.render(
            <ItemAdd value='Mentés' name='A nettó értéke csak szám lehet!' />, document.getElementById('invoiceBody')
        );
    }

    customerGet(companyID) {
        new Customer().customerGetInfo(companyID);
    }

    history() {
        ReactDOM.render(
            <History value="OK" />, document.getElementById('invoiceBody')
        );
    }

    invoiceSelectItems() {
        //var companyID = CustomerProfile.getCompanyID();
        //new Customer().customerDataGet(CustomerProfile.getCompanyID());
        var pDate;
        var pDate2;
        return (
            <div>
                <h1>Számla adatok megadása</h1>
                <div className='calendar'>
                    <div class='date'>
                        <h2>Teljesítés</h2>
                        <Calendar
                            onChange={this.onChange}
                            value={pDate}
                        />
                    </div>
                    <div class='date'>
                        <h2>Fizetés</h2>
                        <Calendar
                            onChange={this.onChange2}
                            value={pDate2}
                        />
                    </div>
                </div>
                <div id='pay'>
                    <select id='category'>
                        <option value='invoice'>Számla</option>
                        <option value='advance'>Előleg</option>
                        <option value='finalBill'>Végszámla</option>
                        <option value='proforma'>Díjbekérő</option>
                    </select>
                    <select id='payment'>
                        <option value='Készpénz'>Készpénz</option>
                        <option value='Bankkártyás'>Bankkártyás</option>
                        <option value='Utalás'>Utalás</option>
                        <option value='Utánvét'>Utánvét</option>
                    </select>
                </div>
                <div id='row'>
                    <button className="push" onClick={() => this.invoiceSum()}>
                        {'Összesít'}
                    </button>
                </div>
            </div >
        );
    }

    invoiceSelect(iData, companyID) {
        CustomerProfile.setCompanyID(companyID);
        CustomerProfile.setInvoiceItems(iData);
        var invoiceItems = this.invoiceSelectItems();
        ReactDOM.render(
            <div>{invoiceItems}</div>, document.getElementById('invoiceBody')
        );
    }

    invoiceRouter() {
        const category = CustomerProfile.getCategory();
        switch (category) {
            case 'invoice':
                this.invoiceSend(category);
                break;
            case 'advance':
                this.invoiceSend(category);
                break;
            case 'finalBill':
                this.finalBillSend(category);
                break;
            case 'proforma':
                this.invoiceSend(category);
                break;
        }
    }

    advanceList() {
        var userID = UserProfile.getUserID();
        var uCompanyID = UserProfile.getCompanyID();
        var companyID = CustomerProfile.getCompanyID();
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        var data = { event: 'advance-id', userID: userID, uCompanyID: uCompanyID, companyID: companyID };
        fetch(url, {
            method: "POST",
            body: new URLSearchParams(data),
            headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
        })
            .then(res => {
                this.isSubmitting = false;
                return res.json();
            })
            .then(
                (result) => {
                    CustomerProfile.setAdvance(result);
                    this.isLoaded = true;
                },
                (error) => {
                    this.isLoaded = true;
                    this.error = error;
                }
            )
    }

    advenceCheck(aData) {
        var i = 0;
        var c = 0;
        var advance = [];
        for (i in aData) {
            if (document.getElementById('ad-' + aData[i]['invoiceID']).checked === true) {
                advance[c] = aData[i]['invoiceID'];
                c++;
            }
        }
        return advance;
    }

    finalBillSend(event) {
        ReactDOM.render(
            <Loader />, document.getElementById('invoiceBody')
        );
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        var iData = CustomerProfile.getInvoiceItems();
        var i = 0;
        var c = 0;
        var items = [];
        var price = [];
        for (i in iData) {
            if (iData[i]['itemID'] !== 'null' && iData[i]['price'] !== 'null') {
                items[c] = iData[i]['itemID'];
                price[c] = iData[i]['price'];
                c++;
            }
        }
        var aData = this.advenceCheck(CustomerProfile.getAdvance());
        const companyID = CustomerProfile.getCompanyID();
        const userID = UserProfile.getUserID();
        const uCompanyID = UserProfile.getCompanyID();
        const payment = CustomerProfile.getPayment();
        const fulfilment = this.dateConvertISO(CustomerProfile.getDate());
        const pDeadline = this.dateConvertISO(CustomerProfile.getDate2());
        var data = new URLSearchParams({
            event: event,
            companyID: companyID,
            userID: userID,
            uCompanyID: uCompanyID,
            payment: payment,
            items: JSON.stringify(items),
            price: JSON.stringify(price),
            fulfilment: fulfilment,
            pDeadline: pDeadline,
            advance: JSON.stringify(aData),
            reverse: false
        });
        Axios.post(url, data)
            .then(res => {
                //window.location.href = UserProfile.getURL() + '/invoice/domPdf.php?pdf=' + res.data;
                window.open(
                    UserProfile.getURL() + '/invoice/domPdf.php?pdf=' + res.data,
                    '_blank',
                    'noopener,noreferrer'
                );
                this.clientsGet();
            })
    }

    invoiceSend(event) {
        ReactDOM.render(
            <Loader />, document.getElementById('invoiceBody')
        );
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        var iData = CustomerProfile.getInvoiceItems();
        var i = 0;
        var c = 0;
        var items = [];
        var price = [];
        for (i in iData) {
            if (iData[i]['itemID'] !== 'null' && iData[i]['price'] !== 'null') {
                items[c] = iData[i]['itemID'];
                price[c] = iData[i]['price'];
                c++;
            }
        }
        const companyID = CustomerProfile.getCompanyID();
        const userID = UserProfile.getUserID();
        const uCompanyID = UserProfile.getCompanyID();
        const payment = CustomerProfile.getPayment();
        const fulfilment = this.dateConvertISO(CustomerProfile.getDate());
        const pDeadline = this.dateConvertISO(CustomerProfile.getDate2());
        var data = new URLSearchParams({
            event: event,
            companyID: companyID,
            userID: userID,
            uCompanyID: uCompanyID,
            payment: payment,
            items: JSON.stringify(items),
            price: JSON.stringify(price),
            fulfilment: fulfilment,
            pDeadline: pDeadline,
            reverse: false
        });
        Axios.post(url, data)
            .then(res => {
                /*console.log(res);
                console.log(res.data);*/
                /*var doc = new jsPDF('p', 'pt', 'a4');
                //doc.text(res.data, 10, 10);
                doc.html(res.data);
                doc.save('sample-file.pdf');*/
                //window.location.href = UserProfile.getURL() + '/invoice/domPdf.php?pdf=' + res.data;
                window.open(
                    UserProfile.getURL() + '/invoice/domPdf.php?pdf=' + res.data,
                    '_blank',
                    'noopener,noreferrer'
                );
                this.clientsGet();
            })
    }

    invoiceInfo() {
        ReactDOM.render(
            <Loader />, document.getElementById('invoiceBody')
        );
        //var advance = null;
        var cData = CustomerProfile.getCustomer();
        var fromDate = CustomerProfile.getDate();
        var toDate = CustomerProfile.getDate2();
        var payment = document.getElementById("payment").value;
        CustomerProfile.setPayment(payment);
        var category = document.getElementById("category").value;
        CustomerProfile.setCategory(category);
        var sel = document.getElementById("category");
        var categoryName = sel.options[sel.selectedIndex].text;
        if (fromDate === '') {
            fromDate = new Date();
            CustomerProfile.setDate(fromDate);
        }
        fromDate = this.dateConvertISO(fromDate);
        if (toDate === '') {
            toDate = new Date();
            CustomerProfile.setDate2(toDate);
        }
        toDate = this.dateConvertISO(toDate);
        if (category === 'finalBill') {
            this.advanceList();
        }
        //krisztian0822 ---> 1982Koncz
        return (
            <ul className='list'>
                <li><span></span>{'Vevő neve:'} {cData.name}</li>
                <li><span></span>{'Teljesítés:'} {fromDate} - {'Fizetési határidő:'} {toDate}</li>
                <li><span></span>{categoryName} - {payment}</li>
            </ul>
        );
    }

    invoiceSum() {
        ReactDOM.render(
            <Loader />, document.getElementById('invoiceBody')
        );
        var iData = CustomerProfile.getInvoiceItems();
        var sum = 0;
        var i = 0;
        var info = this.invoiceInfo();
        var finalize = null;
        var advance = '';
        var aHead = '';
        var category = CustomerProfile.getCategory();
        var abbreviation = UserProfile.getAbbreviation();
        const items = iData.map((data) => <li key={data.itemID}>{data.name} {data.price}</li>);
        for (i in iData) {
            sum = sum + parseInt(iData[i].price);
        }
        sum = <li> <b>Összesen:</b> {sum} </li>;
        finalize = <button className="push" onClick={() => this.invoiceRouter()}>
            {'Véglegesít'}
        </button>;
        //kell egy kis idő az advance adatnak
        setTimeout(function () {
            var aData = CustomerProfile.getAdvance();
            if (category === 'finalBill' && aData !== null) {
                aHead = <li><b>{'Válsztható előlegszámla:'}</b></li>;
                advance = aData.map((data) =>
                    <li key={data.invoiceID}>
                        {'Számlaszám: '}{abbreviation + '-' + data.invoiceID} <input id={'ad-' + data.invoiceID} type='checkbox' value={data.invoiceID} />
                    </li>
                );
            }
            ReactDOM.render(
                <div><ul><li><h1>{'Számla adatok'}</h1></li><li>{info}</li>{items}{sum}{aHead}{advance}</ul>{finalize}</div>, document.getElementById('invoiceBody')
            );
        }, 100);
    }

    historyStornoPrint(coInvoiceID) {
        var uCompanyID = UserProfile.getCompanyID();
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        var data = { event: 'history-storno', invoiceID: coInvoiceID, uCompanyID: uCompanyID };
        fetch(url, {
            method: "POST",
            body: new URLSearchParams(data),
            headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
        })
            .then(res => {
                return res.json();
            })
            .then(
                (result) => {
                    //window.location.href = UserProfile.getURL() + '/invoice/domPdf.php?pdf=' + result
                    window.open(
                        UserProfile.getURL() + '/invoice/domPdf.php?pdf=' + result,
                        '_blank',
                        'noopener,noreferrer'
                    );
                },
                (error) => {
                    this.setState({
                        //console.log(error);
                    });
                }
            )
    }

    historyInvoicePrint(coInvoiceID) {
        var uCompanyID = UserProfile.getCompanyID();
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        var data = { event: 'history-invoice', invoiceID: coInvoiceID, uCompanyID: uCompanyID };
        fetch(url, {
            method: "POST",
            body: new URLSearchParams(data),
            headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
        })
            .then(res => {
                return res.json();
            })
            .then(
                (result) => {
                    //window.location.href = UserProfile.getURL() + '/invoice/domPdf.php?pdf=' + result
                    window.open(
                        UserProfile.getURL() + '/invoice/domPdf.php?pdf=' + result,
                        '_blank',
                        'noopener,noreferrer'
                    );
                },
                (error) => {
                    this.setState({
                        //console.log(error);
                    });
                }
            )
    }

    narrowSet(narrow) {
        var list = document.querySelectorAll('li.list');
        var number = null;
        var id = null;
        list.forEach(function (item) {
            var obj = item;
            var b = obj.textContent;
            b = b.toUpperCase();
            //console.log(b);
            var a = b.search(narrow);
            if (a < 0) {
                obj.style.display = 'none';
            } else {
                obj.style.display = 'block';
                number++;
                id = obj.textContent;
            }
        });
    }

    narrowRead() {
        var narrow = document.getElementById("narow").value;
        narrow = narrow.toUpperCase();
        this.narrowSet(narrow);
    }

    dateConvertISO(date) {
        var res;
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var dt = date.getDate();
        if (dt < 10) {
            dt = '0' + dt;
        }
        if (month < 10) {
            month = '0' + month;
        }
        res = year + '-' + month + '-' + dt;
        return res;
    }

    consoleShow(console) {
        if (console === 'none' || console === '') {
            document.getElementById('console').style.display = 'block';
        } else {
            document.getElementById('console').style.display = 'none';
        }
    }

    render() {
        return (
            <div className='invoice'>
                <div onClick={() => this.consoleShow(document.getElementById('console').style.display)} id='menu'>
                    <span> </span>
                    <span> </span>
                    <span> </span>
                </div>
                <div id="console">
                    <Console />
                </div>
                <div id='invoiceBody'>
                </div>
            </div>
        );
    }

}